import {omit, transform, groupBy, sortBy, minutes, createSelector} from 'helpers';
import {createRestrictedSelector} from 'store/permissions';
import {filter, timestamp, createdDateNegative} from 'store/common';

export const index = state => state.diary.index;

export const dates = createSelector(
  [ index, createRestrictedSelector(index, 'diary') ],
  ( index, isRestricted ) => groupBy(index, record => isRestricted(record) ? 'restricted' : record.date),
);

export const byDate = createSelector(
  [ dates, timestamp, filter ],
  ( dates, timestamp, filter = Boolean ) => sortBy(dates[timestamp], ({ time }) => -1*minutes(time), createdDateNegative).filter(filter),
  { memoizeOptions: { maxSize: 100 } },
);

export const byGoalId = createSelector(
  [ index ],
  ( index ) => groupBy(index, 'goalId'),
);

export const byActivityId = createSelector(
  [ index ],
  ( index ) => groupBy(index, 'taskId'),
);

export const list = createSelector(
  [ dates ],
  ( dates ) => sortBy(omit(dates, 'restricted'), '0.date').map(group => ({
    date: group[0].date,
    accumulated: transform(group, (accumulated, record) => {
      accumulated.subject += record.subject + ' ';
      accumulated.text += record.text + ' ';
      accumulated.tagIds += record.tagIds + ' ';
    }, { subject: '', text: '', tagIds: '' })
  }))
);
